<template>
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
		<path
			d="M9 3h6M10 3v5.3l-5.3 9.1A2.4 2.4 0 0 0 6.8 21h10.4a2.4 2.4 0 0 0 2.1-3.6L14 8.3V3"
			stroke="currentColor"
			stroke-width="1.8"
			stroke-linecap="round"
			stroke-linejoin="round"
		></path>
		<path d="M7.1 14.5h9.8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"></path>
		<circle cx="10.4" cy="17.6" r="1" fill="currentColor"></circle>
		<circle cx="13.9" cy="16.9" r="0.8" fill="currentColor"></circle>
	</svg>
</template>
